<template>
  <div class="upload-info">
    <a-form :form="form" loading="true" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }" @submit="handleSubmit">
      <div class="form-title">
        合同信息
      </div>
      <a-form-item label="合同名称">
        <a-input placeholder="请输入合同名称"
                 v-decorator="['contractName', { rules: [{ required: true, message: '请输入合同名称!' }] }]"
        />
      </a-form-item>
      <a-form-item label="合同类型">
        <a-select
            v-decorator="['contractType',{ rules: [{ required: true, message: '请选择合同类型!' }] },]"
            placeholder="请选择合同类型">
          <a-select-option value="1">买卖合同</a-select-option>
          <a-select-option value="2">供用电、水、气、热力合同</a-select-option>
          <a-select-option value="3">赠与合同</a-select-option>
          <a-select-option value="4">借款合同</a-select-option>
          <a-select-option value="5">租赁合同</a-select-option>
          <a-select-option value="6">融资租赁合同</a-select-option>
          <a-select-option value="7">承揽合同</a-select-option>
          <a-select-option value="8">建设工程合同</a-select-option>
          <a-select-option value="9">运输合同</a-select-option>
          <a-select-option value="10">技术合同</a-select-option>
          <a-select-option value="11">保管合同</a-select-option>
          <a-select-option value="12">仓储合同</a-select-option>
          <a-select-option value="13">委托合同</a-select-option>
          <a-select-option value="14">行纪合同</a-select-option>
          <a-select-option value="15">居间合同</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="签订日期">
        <a-date-picker :format="dateFormat"
                       v-decorator="['startTime', { rules: [{ required: true, message: '请选择签订日期!' }] }]"
                       style="width: 100%"/>
      </a-form-item>
      <a-form-item label="终止日期">
        <a-date-picker :format="dateFormat"
                       v-decorator="['endTime', { rules: [{ required: true, message: '请选择终止日期!' }] }]"
                       style="width: 100%"/>
      </a-form-item>
      <a-form-item label="合同金额">
        <a-input-number style="width:140px;" :min="0"
                        v-decorator="['contractMoney', { rules: [{ required: true, message: '请输入合同金额!' }] }]"/>
      </a-form-item>
      <a-form-item label="违约日期">
        <a-date-picker :format="dateFormat"
                       v-decorator="['wyTime', { rules: [{ required: true, message: '请选择违约日期!' }] }]"
                       style="width: 100%"/>
      </a-form-item>
      <a-form-item label="违约条款">
        <a-textarea placeholder="请输入合同中违约的款项"
                    v-decorator="['reason', { rules: [{ required: true, message: '请输入社会统一信用代码!' }] }]"/>
      </a-form-item>

      <a-form-item label="上传证据">
        <div class="clearfix">
          <a-upload
              list-type="picture-card"
              accept=".jpg,.jpeg,.png"
              :file-list="fileList"
              :multiple="true"
              :before-upload="beforeUpload"
              @preview="handlePreview"
              @change="handleChange"
          >
            <div v-if="fileList.length < 5">
              <a-icon type="plus"/>
              <div class="ant-upload-text">
                上传
              </div>
            </div>
          </a-upload>
          <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
            <img alt="example" style="width: 100%" :src="previewImage"/>
          </a-modal>
        </div>
      </a-form-item>
      <div class="form-title">
        主体信息
      </div>
      <div style="position: relative" v-for="(item, index) in childFormList" :key="index">
        <a-form-item label="主体类型">
          <a-select placeholder="请选择主体类型"
                    v-decorator="['childFormList['+index+'].type', {'initialValue':item.type,rules: [{ required: true, message: '请选择类型!' }]}]">
            <a-select-option value="1">企业或其他组织</a-select-option>
            <a-select-option value="2">自然人</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="法定全称">
          <a-input placeholder="请输入法定全称/姓名"
                   v-decorator="['childFormList['+index+'].oname', {'initialValue':item.oname,rules: [{ required: true, message: '请输入法定全称/姓名!' }]}]"/>
        </a-form-item>
        <a-form-item label="信用代码">
          <a-input placeholder="请输入统一社会信用代码/身份证号码"
                   v-decorator="['childFormList['+index+'].uccode', {'initialValue':item.name,rules: [{ required: true, message: '请输入统一社会信用代码/身份证号码!' }]}]"/>
        </a-form-item>
        <a-form-item label="联系地址">
          <a-input placeholder="请输入联系地址"
                   v-decorator="['childFormList['+index+'].address', {'initialValue':item.address,rules: [{ required: true, message: '请输入联系地址!' }]}]"/>
        </a-form-item>
        <a-form-item label="联系人姓名">
          <a-input placeholder="请输入联系人姓名"
                   v-decorator="['childFormList['+index+'].contactName', {'initialValue':item.contactName,rules: [{ required: true, message: '请输入联系人姓名!' }]}]"/>
        </a-form-item>
        <a-form-item label="联系电话">
          <a-input placeholder="请输入联系电话"
                   v-decorator="['childFormList['+index+'].telephone', {'initialValue':item.telephone,rules: [{ required: true, message: '请输入联系电话!' }]}]"/>
        </a-form-item>
        <a-form-item label="电子邮箱">
          <a-input placeholder="请输入电子邮箱"
                   v-decorator="['childFormList['+index+'].email', {'initialValue':item.email,rules: [{ required: true, message: '请输入电子邮箱!' }]}]"/>
        </a-form-item>
        <a-button style="position: absolute;top: 50%;left: 85%;" icon="minus" @click="delRowCustom(index)"></a-button>
        <a-divider type="horizontal" :dashed="false"/>
      </div>
      <a-form-item :wrapper-col="{ span: 12, offset: 8 }">
        <a-button style="width: 400px;margin-top: 20px;" icon="plus" @click="addRowCustom">新增主体信息</a-button>&nbsp;
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 12, offset: 10 }">
        <a-button style="background: #d7000f;border: #d7000f;width: 150px" type="primary" html-type="submit">
          提交
        </a-button>
      </a-form-item>
    </a-form>
  </div>

</template>
<script>
import Vue from 'vue'
import {ACCESS_TOKEN} from '@/store/mutation-types'
import {getBase64} from "@/api/Base64";
import {postActionTimeout} from "@/api/manage";

const key = 'saveData'
export default {
  data() {
    return {
      dateFormat: 'yyyy-MM-DD',
      form: this.$form.createForm(this),
      previewVisible: false,
      previewImage: '',
      fileList: [],
      childFormList: [{}],
    };
  },
  created() {
    const token = Vue.ls.get(ACCESS_TOKEN);
    this.headers = {"X-Access-Token": token}
  },
  methods: {
    handleCancel() {
      this.previewVisible = false;
    },
    beforeUpload(file) {
      this.fileList = [...this.fileList, file];
      return false;
    },
    async handlePreview(file) {
      console.log(file)
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    handleChange({fileList}) {
      this.fileList = fileList;
    },
    addRowCustom() {
      this.childFormList.push({});
      this.$forceUpdate();
    },
    handleEmailCheck(rule, value, callback) {
      const regEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
      if (!regEmail.test(value)) {
        callback(new Error('邮箱格式不正确'))
      }
      callback()
    },
    delRowCustom(index) {
      console.log(index)
      let all = this.form.getFieldsValue()
      all['childFormList'].splice(index, 1);
      this.form.setFieldsValue(all)
      this.childFormList.splice(index, 1);
      this.$forceUpdate();
    },
    handleSubmit(e) {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$message.loading({content: '数据提交中...', key});
          const formData = new FormData();
          formData.append('contractName', values.contractName);
          formData.append('contractType', values.contractType);
          formData.append('startTime', values.startTime.format('yyyy-MM-DD'));
          formData.append('endTime', values.endTime.format('yyyy-MM-DD'));
          formData.append('contractMoney', values.contractMoney)
          formData.append('wyTime', values.wyTime.format('yyyy-MM-DD'));
          formData.append('reason', values.reason);
          // formData.append('uploadTime', values.uploadTime.format('yyyy-MM-DD'));
          this.fileList.forEach(file => {
            formData.append('files', file.originFileObj);
          });
          if (values.childFormList) {
            formData.append('childFormList', JSON.stringify(values.childFormList));
          }
          postActionTimeout("/announce/upload", formData, 0).then((res) => {
            if (res.success) {
              this.$message.success({content: '数据提交成功!', key, duration: 2});
              this.fileList = []
              this.form.resetFields();
            } else {
              this.$message.error({content: '数据提交失败!', key, duration: 2});
            }
          }).catch((error) => {
            this.$message.error({content: '数据提交失败!', key, duration: 2});
            console.log("上传失败：" + error)
          })
        }
      });
    },
  },
};
</script>
<style>
.upload-info {
  width: 1200px;
  margin: 20px auto;
  background: #FFFFFF;
}

/* you can make up upload button and sample style by using stylesheets */
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.form-title {
  width: 1200px;
  height: 40px;
  line-height: 40px;
  color: #FFFFFF;
  background: #E22323;
  font-weight: bold;
  padding-left: 20px;
}
</style>
